import { bluePaletteDark, grayPaletteDark, redPaletteDark } from '../../themes/dark-colors';

export const checkboxDarkTheme = {
  iconColor: grayPaletteDark[0],
  backgroundColor: grayPaletteDark[0],
  borderColor: grayPaletteDark[500],
  checked: {
    backgroundColor: bluePaletteDark[700],
    borderColor: bluePaletteDark[700],
  },
  disabled: {
    backgroundColor: grayPaletteDark[500],
    borderColor: grayPaletteDark[500],
  },
  list: {
    backgroundColor: {
      inactive: redPaletteDark[100],
      hover: {
        default: grayPaletteDark[100],
        inactive: redPaletteDark[200],
      },
    },
  },
};
